import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1 className="hero-title">
            AI-Powered Insulation Estimates<br />
            <span className="text-primary">in Minutes, Not Hours</span>
          </h1>
          <p className="hero-subtitle">
            Upload your floor plans and let our AI detect rooms, calculate measurements,
            and generate professional insulation estimates automatically.
          </p>
          <div className="hero-cta">
            <Link to="/download" className="btn btn-primary btn-large">
              Download Free Trial
            </Link>
            <a href="#features" className="btn btn-secondary btn-large">
              See How It Works
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title">Why Contractors Choose PlanScan</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📐</div>
              <h3 className="feature-title">AI Floor Plan Analysis</h3>
              <p className="feature-desc">
                Upload PDFs or images. Our AI automatically detects rooms,
                measures dimensions, and identifies insulation requirements.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3 className="feature-title">Accurate Cost Estimates</h3>
              <p className="feature-desc">
                Material costs, labor estimates, and climate zone compliance
                calculated automatically with your custom pricing.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📄</div>
              <h3 className="feature-title">Professional PDF Reports</h3>
              <p className="feature-desc">
                Generate polished, branded estimates ready to send to customers
                in seconds, not hours.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏠</div>
              <h3 className="feature-title">Works Offline</h3>
              <p className="feature-desc">
                Desktop application works without internet. Perfect for
                job site visits and remote areas.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3 className="feature-title">Derek-Proof Simple</h3>
              <p className="feature-desc">
                Large buttons, clear labels, high contrast. Designed so anyone
                on your team can create estimates.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3 className="feature-title">Your Data Stays Yours</h3>
              <p className="feature-desc">
                All data stored locally on your computer. No cloud uploads,
                no data sharing, no privacy concerns.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing">
        <div className="container">
          <h2 className="section-title">Simple Pay-Per-Plan Pricing</h2>
          <p className="section-subtitle">No subscriptions. No monthly fees. Credits never expire.</p>
          <div className="pricing-grid pricing-grid-2">
            <div className="pricing-card featured">
              <span className="pricing-badge">Most Popular</span>
              <h3 className="pricing-name">Single-Family Plan</h3>
              <div className="pricing-price">$45<span>/plan</span></div>
              <ul className="pricing-features">
                <li>AI-powered insulation analysis</li>
                <li>Complete takeoff report</li>
                <li>PDF export included</li>
                <li>Never expires</li>
              </ul>
              <Link to="/pricing" className="btn btn-primary">Buy Credits</Link>
            </div>
            <div className="pricing-card">
              <h3 className="pricing-name">Multi-Unit Plan</h3>
              <div className="pricing-price">$75<span>/plan</span></div>
              <ul className="pricing-features">
                <li>AI-powered insulation analysis</li>
                <li>Complete takeoff report</li>
                <li>PDF export included</li>
                <li>Never expires</li>
              </ul>
              <Link to="/pricing" className="btn btn-secondary">Buy Credits</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section id="download" className="features">
        <div className="container text-center">
          <h2 className="section-title">Download PlanScan</h2>
          <p className="hero-subtitle">
            Available for macOS and Windows. Start your 14-day free trial today.
          </p>
          <div className="hero-cta">
            <Link to="/download" className="btn btn-primary btn-large">
              Download for Mac
            </Link>
            <Link to="/download" className="btn btn-secondary btn-large">
              Download for Windows
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
